import { render, staticRenderFns } from "./Korisnici.vue?vue&type=template&id=9fdda088"
import script from "./Korisnici.vue?vue&type=script&lang=js"
export * from "./Korisnici.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports